import type { NextPage } from "next";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
import styles from "@/styles/pages/payments/DeleteAccount.module.scss";
import Head from "next/head";
import { feedbackEmail } from "@/constants/feedbackEmail.constant";
import { StreamName, useRegisterStream } from "@/modules/analytics";
import { OGImage } from "@/components/og-image/og-image";

const DeleteAccount: NextPage = () => {
  const { t } = useTranslation("web-payments");
  useRegisterStream(StreamName.DeleteAccount);

  return (
    <>
      <Head>
        <title>{`${t`DELETE_ACCOUNT_PAGE_TITLE`} | OneFootball`}</title>
        <OGImage />
      </Head>
      <div className={styles.wrapper}>
        <h1 className={styles.header}>
          <span className={styles.title}>{t`DELETE_ACCOUNT_PAGE_TITLE`}</span>
        </h1>
        <div className={styles.description}>
          <p className={styles.text}>{t`DELETE_ACCOUNT_PAGE_DESCRIPTION`}</p>
          <p className={styles.text}>
            <Trans
              i18nKey="web-payments:DELETE_ACCOUNT_PAGE_CTA"
              components={{
                a: (
                  <a
                    className={styles.textAnchor}
                    href={`mailto:${feedbackEmail}`}
                  >
                    {feedbackEmail}
                  </a>
                ),
              }}
            />
          </p>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
